import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '@src/environments/environment';
import { UtilsService } from '@shared/services/utils.service';

export const authGuard: CanActivateFn = (route, state) => {
  if (!environment.production) {
    return true;
  }

  const router = inject(Router);
  const loggedIn = UtilsService.getUserToken();
  if (loggedIn != null) {
    return true;
  } else {
    router.navigate(['/unauthorized'])
    return false;
  }
};
